import classes from './SignupItem.module.css';
import { useQueryClient } from '@tanstack/react-query';

function SignupItem(props) {
	let signupQty = 0;
	let signupID = 0; 
	const thePoster = (typeof props.poster === 'undefined') ? null : props.poster[0];
	const queryClient = useQueryClient();
	const userSignups = queryClient.getQueryData(['signups', props.email]);

	if (typeof userSignups === 'undefined') { return false; }
	const filteredSignups = userSignups.filter((signup) => signup.fields.Parent[0] === props.id);
	filteredSignups.forEach((signup, idx) => {
		signupQty += 10 * signup.fields.Quantity; 
		signupID = signup.id;	
	});
	function signupHandler() {
		const signupData = {
			id:			props.id,
			limit:		Math.max(props.remaining, signupQty), 
			title:		activityName,
			deadline: 	props.deadline,
			poster:		props.poster,
			text:		props.text,
			signupQty:	signupQty, 
			signupID: 	signupID,
		}
		props.showSignupForm(signupData);
	}

	const rawDate = new Date(props.deadline);
	const options = { 
		weekday: 'short', 
		year: 'numeric', 
		month: 'short', 
		day: 'numeric',
		timeZone: 'UTC', 
	};
	const outDate = rawDate.toLocaleDateString('en-US', options);
	var activityName=props.activity.replace('cards', '',);
	activityName=activityName.replace('Cards', '',);
	activityName=activityName.replace(', set of 10', '',);
	activityName=activityName.replace(', Set of 10', '',);
	const theLabel = (signupQty>0) ? "Update" : "Signup";

	if (props.remaining <= 1 || props.status !== "OPEN") {
		return (
			<div className={classes.mutedBlock}>
				<div className={classes.mutedTitleHeader}>{activityName}</div>
				<div className={classes.btnDiv}>[CLOSED]</div>
				<div className={classes.suggest}>
					See <a href={thePoster} rel="noreferrer" target={"_blank"}>card making suggestions</a>
				</div>
			</div>		
		)
	}

	return (
		<div className={classes.signupBlock}>
			<div className={classes.titleHeader}>{activityName}</div>
			<div className={classes.deadline}>
				<span>Deadline: {outDate} </span>
				{signupQty>0 && <div className={classes.signupMsg}>You have already signed up for {signupQty} cards</div> }
			</div>
			<div className={classes.btnDiv}>
				<button className={classes.btn}	onClick={signupHandler}>{theLabel}</button>
			</div>
			<div className={classes.suggest}>
				See <a href={thePoster} rel="noreferrer" target={"_blank"}>card making suggestions</a>
			</div>
		</div>
	)
		
}

export default SignupItem;
